module.exports = {
  familyName: 'Arial',
  category: 'sans-serif',
  capHeight: 1467,
  ascent: 1854,
  descent: -434,
  lineGap: 67,
  unitsPerEm: 2048,
  xHeight: 1062,
  xWidthAvg: 904
};
